import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/components/breadcrumb.css';

/**
 * Barra de breadcrumb reutilizable para navegación jerárquica
 *
 * @param {Object} props
 * @param {Array<{label: string, to?: string}>} props.items - Elementos del breadcrumb. El último elemento es la página actual (sin link).
 * @param {React.ReactNode} [props.children] - Acciones opcionales al lado derecho
 * @returns {JSX.Element}
 */
function Breadcrumb({ items, children }) {
  return (
    <div className="wf-breadcrumb-bar">
      <ol className="wf-breadcrumb" aria-label="Ruta de navegación">
        {items.map((item, index) => (
          <React.Fragment key={index}>
            {index > 0 && <li className="wf-breadcrumb-sep" aria-hidden="true">›</li>}
            {item.to ? (
              <li><Link to={item.to}>{item.label}</Link></li>
            ) : (
              <li className="wf-breadcrumb-current" aria-current="page">{item.label}</li>
            )}
          </React.Fragment>
        ))}
      </ol>
      {children && <div className="wf-breadcrumb-actions">{children}</div>}
    </div>
  );
}

export default Breadcrumb;
